import { formatPublicationDate } from './publication-date'

export function formatPortfolioDate(value?: string | null): string {
    return formatPublicationDate(value, true)
}
